const state = {
  versionNo: 'RLS.20230217.1400',
  currentFrontendType: 'PROJ',
  NA_VALUE: 'NA',
  NA_VALUE_NUM: 0,
  language: 'zh',
  role: '',
  globalCompId: '',
  globalCompIdDDList: [],
  reqLog: [],
  projStatusList: [
    // {value: 'TODO', status: 'A'},
    {value: 'IN_DEV', status: 'A'},
    // {value: 'PAUSE', status: 'A'},
    // {value: 'CANCEL', status: 'A'},
    {value: 'DONE', status: 'A'}
  ],
  indList: [
    {value: 'Y', status: 'A'},
    {value: 'N', status: 'A'}
  ],
  indUsedList: [
    {value: 'Y', status: 'A'},
    {value: 'N', status: 'A'}
  ],
  statusList: [
    {value: 'A', status: 'A'},
    {value: 'I', status: 'A'}
  ],
  rptStatusList: [
    // {value: 'TODO', status: 'A'},
    {value: 'IN_DEV', status: 'A'},
    // {value: 'PAUSE', status: 'A'},
    {value: 'DONE', status: 'A'}
  ],
  paymentTypeList: [
    {value: 'CASH', status: 'A'},
    {value: 'WITHHOLD', status: 'A'},
    {value: 'TRANSFER', status: 'A'}
  ],
  invPaymentTypeList: [
    {value: 'CASH', status: 'A'},
    {value: 'TRANSFER', status: 'A'}
  ],
  entityStatusList: [
    // {value: 'TODO', status: 'A'},
    {value: 'IN_DEV', status: 'A'},
    // {value: 'PAUSE', status: 'A'},
    {value: 'DONE', status: 'A'}
  ],
  incomeTypeList: [
    {value: 'PROJ_FUND', status: 'A'},
    {value: 'OTH_INCOME', status: 'A'},
    {value: 'PROJ_OUT_VAT', status: 'A'},
    {value: 'TRANSFER', status: 'A'}
  ],
  ctrAcctTypeList: [
    {value: 'PM', status: 'A'},
    {value: 'PRI', status: 'A'},
    {value: 'SND', status: 'A'}
  ],
  projUserRoleList: [
    {value: 'SETTLE', status: 'A'},
    {value: 'MGR', status: 'A'},
    {value: 'TAB', status: 'A'}
  ],
  transDtSearchTypeList: [
    {value: 'ALL', status: 'A'},
    {value: 'MONTH', status: 'A'},
    {value: 'DT_SCOPE', status: 'A'}
  ],
  transDt2SearchTypeList: [
    {value: 'ALL', status: 'A'},
    {value: 'YEAR', status: 'A'},
    {value: 'MONTH', status: 'A'},
    {value: 'DT_SCOPE', status: 'A'}
  ],
  transDtSearchYearTypeList: [
    { value: 'CURRENT', descr: '当年', status: 'A' },
    { value: 'TOTAL', descr: '累计', status: 'A' }
  ],
  transDtSearchMonthTypeList: [
    { value: 'CURRENT', descr: '当月', status: 'A' },
    { value: 'TOTAL', descr: '累计', status: 'A' }
  ],
  columnNameUpperList: [
    {value: 'SETTLE', status: 'A'},
    {value: 'INCOME', status: 'A'},
    {value: 'ACCT_PAY', status: 'A'},
    {value: 'ACCT_RECEIVE', status: 'A'},
    {value: 'ACCT_CUR', status: 'A'}
    // ,
    // {value: 'INVEST_FIN', status: 'A'}
  ],
  checkedList: [
    {value: 'true', status: 'A'},
    {value: 'false', status: 'A'}
  ],
  checkedStatusList: [
    {value: 'U', status: 'A'},
    {value: 'F', status: 'A'},
    {value: 'P', status: 'A'}
  ],
  projSettleDtNumList: [],
  searchMonthTypeList: [
    {value: 'CURRENT', status: 'A'},
    {value: 'TOTAL', status: 'A'}
  ],
  invTypeList: [
    {value: 'SPECIAL', status: 'A'},
    {value: 'TAX', status: 'A'},
    {value: 'QUOTA', status: 'A'},
    {value: 'BY_MACHINE', status: 'A'},
    {value: 'E_INV', status: 'A'}
  ],
  invCertStatusList: [
    {value: 'IN_DEV', status: 'A'},
    {value: 'DONE', status: 'A'}
  ],
  rptStatusColor: {
    IN_DEV: 'blue',
    CHECKING: 'primary',
    MODIFYING: 'red',
    DONE: 'success'
  },
  END: null
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js